import { useMediaQuery } from '@mui/material';
import BudgetSummaryMobile from './mobile/BudgetSummaryMobile';

interface IBudgetSummaryProps {
  subtotal?: number;
  discounts?: number;
  subscriptionBalanceApplied?: number;
  subscriptionBalanceAvailable?: number;
  subscriptionTotalApproved?: number;
  totalToPay?: number;
  counterProposalValue?: number;
  counterProposalAcceptedAt?: string | null;
}

const formatCurrencyDisplay = (value: number | undefined): string => {
  if (value === undefined || value === null || value === 0) {
    return 'R$ 00,00';
  }

  const reais = Math.floor(value);
  const centavos = Math.round((value - reais) * 100);

  const formattedReais = reais.toLocaleString('pt-BR');
  const formattedCentavos = String(centavos).padStart(2, '0');

  return `R$ ${formattedReais},${formattedCentavos}`;
};

const BudgetSummary = (props: IBudgetSummaryProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <BudgetSummaryMobile
        subtotal={props.subtotal}
        discounts={props.discounts}
        subscriptionBalanceApplied={props.subscriptionBalanceApplied}
        totalToPay={props.totalToPay}
        counterProposalValue={props.counterProposalValue}
        counterProposalAcceptedAt={props.counterProposalAcceptedAt}
      />
    );
  }
  
  return (
    <div className="flex justify-between text-right border border-gray-200 rounded-md p-4 uppercase">
      <div className='bg-[#00F90C1A] flex items-center px-10 gap-4'>
        <p className='text-gray-600'>Saldo disponível do cliente:</p>
        <p className='text-[#2A3740] font-bold'>{formatCurrencyDisplay(props.subscriptionBalanceAvailable)}</p>
      </div>
      <div className="flex flex-col gap-3 font-semibold">
        <div className="text-size-16 mb-1 text-gray-500">
          Subtotal: {formatCurrencyDisplay((props.subtotal ?? 0) + (props.subscriptionTotalApproved ?? 0))}
        </div>
        <div className="text-size-16 mb-1 text-green-500">
          Descontos: {formatCurrencyDisplay(props.discounts)}
        </div>
        {props.subscriptionTotalApproved ? <div className="text-size-16 mb-1 text-green-500">
          VALOR APROVADO PLANO DE MANUTENÇÃO: {formatCurrencyDisplay(props.subscriptionTotalApproved)}
        </div> : null}
        {props.subscriptionBalanceApplied ? <div className="text-size-16 mb-1 text-gray-500">
          SALDO A SER UTILIZADO: {formatCurrencyDisplay(props.subscriptionBalanceApplied)}
        </div> : null}
        <div className={`text-size-16 font-bold mb-1 text-[#2A3740] ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          VALOR A SER PAGO PELO CLIENTE: {formatCurrencyDisplay(props.totalToPay)}
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="text-size-16 font-bold mb-4 text-[#2A3740]">
            VALOR A SER PAGO PELO CLIENTE: {formatCurrencyDisplay(props.counterProposalValue)}
          </div>
        )}
      </div>
    </div>
  );
};

export default BudgetSummary;

